export default __webpack_public_path__ + "static/media/data_hall_v7.8b31f56e.jpg";